import React from 'react'
import PropTypes from 'prop-types'

import omit from 'lodash/omit'

import Button from '@eig-builder/core-ui/Button'
import CircularProgress from '@eig-builder/core-ui/CircularProgress'

import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  loader: {
    verticalAlign: 'middle',
    marginLeft: theme.spacing(4)
  }
}))

const ButtonWithLoader = props => {
  const classes = useStyles()

  return <Button
    dataElementLocation={DataElementLocations.BODY}
    dataElementLabel={`cst-core-button-with-loader--${props.dataElementSuffix}`}
    dataElementId={`cst-core-button-with-loader--${props.dataElementSuffix}`}
    disabled={props.showLoader}
    {...omit(props, 'dataElementSuffix', 'showLoader', 'text')}
  >
    {props.text}
    {
      props.showLoader && <CircularProgress className={classes.loader} size={20} />
    }
  </Button>
}

ButtonWithLoader.propTypes = {
  dataElementSuffix: PropTypes.string.isRequired,
  showLoader: PropTypes.bool.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
}

export default ButtonWithLoader
